import { render, staticRenderFns } from "./RecPL_List.vue?vue&type=template&id=2c8af86d"
import script from "./RecPL_List.vue?vue&type=script&lang=js"
export * from "./RecPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports